import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {AuthService} from '../../../utility/auth-service';
import {HeaderProvider} from './header-provider';
import {Observable} from 'rxjs';
import 'rxjs/add/observable/interval';
import {MatDialog} from '@angular/material';
import {ChangePasswordComponent} from '../../mycomponents/shared/change-password/change-password.component';
import {HttpRequest} from '@angular/common/http';
import {HttpClient} from '@angular/common/http';
import {MasterProvider} from '../../../utility/MasterProvider';
import {Injector} from '@angular/core';
import {Setting_GeneratorComponent} from '../../admin/setting_generator/setting_generator.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    buisness: any;
    loginUserRole: string;
    businessName: any;
    systemDateWithTime: Date;
    loginUserName: string;
    validityDate: any;
    callWaiterList: any;
    pushRightClass: string = 'push-right';
    v_UserName:string;
    notificationCount: number = 0;
    messageCount: number = 0;

    constructor(private translate: TranslateService, public router: Router, public provider: MasterProvider,
        public injector: Injector,
        public auth:AuthService, public providerr: HeaderProvider,
        private dialog: MatDialog, ) {

        this.translate.addLangs(['en', 'fr', 'ur', 'es', 'it', 'fa', 'de', 'zh-CHS','hi']);
        this.translate.setDefaultLang('en');
        const browserLang = this.translate.getBrowserLang();
        this.translate.use(browserLang.match(/en|fr|ur|es|it|fa|de|zh-CHS|hi/) ? browserLang : 'en');

        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });
    }

    ngOnInit() {
        this.getLoginUser();
//         this.loginUserRole = this.auth.getSession().userType;
        this.loginUserRole = this.auth.getSession().User_Role;
        this.v_UserName = this.auth.getSession().email;
        this.businessName = "EntryLogs";
    }
    dashboard(){
         this.router.navigate(['/dashboard']);
    }
   getLoginUser(){
        console.log(this.auth.getSession());
        this.provider.doHttpPost("/api/estimate/getUser", this.auth.getSession().email, true).subscribe((res:any) =>{
            console.log(res);
            this.buisness=res.bussinessName
        });
    }
    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    rltAndLtr() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle('rtl');
    }

    onLoggedout() {
        console.log(localStorage.length);
        localStorage.removeItem('isLoggedin');
        localStorage.clear();
        console.log(localStorage);
    }

    changeLang(language: string) {
        this.translate.use(language);
       
        localStorage.setItem('lan',language);
        
         this.translate.setDefaultLang(language);
    }
    
    getCurrentTimmer()
    {
        Observable.interval(100).subscribe(() =>
        {
            this.systemDateWithTime = new Date();
        })
    }
    setting()
    {
          let dialogBoxSettings = {
            width: '400px',
            height: '360px',
            disableClose: true,
            hasBackdrop: true,
            margin: '0, auto',
        }
        const dialogRef = this.dialog.open(Setting_GeneratorComponent, dialogBoxSettings);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('Yes clicked');
            }
        });
       
    }
    showChangePasswordDialog() {
        let dialogBoxSettings = {
            width: '400px',
            height: '360px',
            disableClose: true,
            hasBackdrop: true,
            margin: '0, auto',
        }
        const dialogRef = this.dialog.open(ChangePasswordComponent, dialogBoxSettings);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('Yes clicked');
            }
        });
    }
    
}
